var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// node_modules/.pnpm/vue-demi@0.12.5_vue@3.2.33/node_modules/vue-demi/lib/index.mjs
var lib_exports = {};
__export(lib_exports, {
  Vue: () => Vue,
  Vue2: () => Vue2,
  del: () => del,
  install: () => install,
  isVue2: () => isVue2,
  isVue3: () => isVue3,
  set: () => set
});
__reExport(lib_exports, vue_star);
import * as Vue from "vue";
import * as vue_star from "vue";
var isVue2 = false;
var isVue3 = true;
var Vue2 = void 0;
function install() {
}
function set(target, key, val) {
  if (Array.isArray(target)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val;
  }
  target[key] = val;
  return val;
}
function del(target, key) {
  if (Array.isArray(target)) {
    target.splice(key, 1);
    return;
  }
  delete target[key];
}

// node_modules/.pnpm/@vueuse+shared@8.4.2_vue@3.2.33/node_modules/@vueuse/shared/index.mjs
function createGlobalState(stateFactory) {
  let initialized = false;
  let state;
  const scope = (0, lib_exports.effectScope)(true);
  return () => {
    if (!initialized) {
      state = scope.run(stateFactory);
      initialized = true;
    }
    return state;
  };
}
function tryOnScopeDispose(fn) {
  if ((0, lib_exports.getCurrentScope)()) {
    (0, lib_exports.onScopeDispose)(fn);
    return true;
  }
  return false;
}

// src/ObserverComponent.ts
import { defineComponent, h } from "vue";
import { reaction } from "mobx";
var ObserverComponent_default = defineComponent({
  data: () => ({
    key: 0,
    dispose: () => {
    }
  }),
  mounted() {
    this.dispose = reaction(() => {
      var _a, _b;
      return (_b = (_a = this.$slots).default) == null ? void 0 : _b.call(_a);
    }, () => {
      this.forceUpdate();
    }, {
      requiresObservable: true
    });
  },
  unmounted() {
    this.dispose();
  },
  methods: {
    forceUpdate() {
      this.key++;
    }
  },
  render() {
    return h(this.$slots.default, { key: this.key });
  }
});

// src/use-local-observable.ts
import { shallowRef as shallowRef2, triggerRef } from "vue";
import { observable, observe } from "mobx";
function useLocalObservable(initializer, annotations) {
  const localObservable = shallowRef2(observable(initializer(), annotations, { autoBind: true }));
  const dispose = observe(localObservable.value, () => {
    triggerRef(localObservable);
  });
  tryOnScopeDispose(() => {
    dispose();
  });
  return localObservable;
}

// src/index.ts
var Plugin = {
  install: (app) => {
    app.component("Observer", ObserverComponent_default);
  }
};
var src_default = Plugin;
export {
  ObserverComponent_default as Observer,
  Plugin,
  createGlobalState as createGlobalObservable,
  src_default as default,
  useLocalObservable
};
